import { useState } from 'react';
import { MembersManagementHeader } from '@/components/common/members-management';
import type { CompanyMembersScope } from './company-api';
import { CompanyMembersDataPanel } from './CompanyMembersDataPanel';
import { CompanyMembersHeaderActions } from './CompanyMembersHeaderActions';
import { useCompanyMemberMutations } from './useCompanyMemberMutations';
import { useCompanyMembersList } from './useCompanyMembersList';
import { useCompanyScopeName } from './useCompanyScopeName';

interface CompanyMembersPageProps {
  createPath: string;
  scope: CompanyMembersScope;
}

export function CompanyMembersPage({ createPath, scope }: CompanyMembersPageProps) {
  const [filterSheetOpen, setFilterSheetOpen] = useState(false);
  const companyName = useCompanyScopeName(scope);
  const list = useCompanyMembersList(scope);
  const mutations = useCompanyMemberMutations(scope, list.query, list.queryKey);
  const title = scope.type === 'targeted'
    ? `Membres · ${companyName ?? 'Entreprise sélectionnée'}`
    : 'Membres de l’entreprise';
  const description = scope.type === 'targeted'
    ? 'Administration ciblée, sans changer l’entreprise active.'
    : 'Gestion des comptes, invitations et rôles de l’entreprise active.';

  return (
    <section className="flex w-full flex-col gap-6" data-testid="company-members-page">
      <MembersManagementHeader
        actions={(
          <CompanyMembersHeaderActions
            createPath={createPath}
            isRefreshing={list.membersQuery.isFetching}
            onRefresh={() => { void list.membersQuery.refetch(); }}
            onReset={list.resetControls}
          />
        )}
        count={list.membersQuery.data?.meta.total ?? 0}
        description={description}
        title={title}
      />
      <CompanyMembersDataPanel
        filterSheetOpen={filterSheetOpen}
        list={list}
        mutations={mutations}
        onFilterSheetOpenChange={setFilterSheetOpen}
      />
    </section>
  );
}
